export const SwooshRightLight = () => {
    return (
        <svg
            width="712"
            height="165"
            viewBox="0 0 712 165"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.3"
                d="M802.546 9.00044C741.076 60.3756 631.546 153.222 407.42 153.221C222.046 153.221 128.546 134.5 6.54639 52"
                stroke="url(#swoosh-right-light-gradient)"
                strokeWidth="23"
            />
            <defs>
                <linearGradient
                    id="swoosh-right-light-gradient"
                    x1="684.487"
                    y1="125.238"
                    x2="-189.961"
                    y2="28.6035"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DEEBFF" />
                    <stop
                        offset="0.546875"
                        stopColor="#DEEBFF"
                        stopOpacity="0"
                    />
                    <stop
                        offset="0.734375"
                        stopColor="#DEEBFF"
                        stopOpacity="0"
                    />
                    <stop offset="1" stopColor="#DEEBFF" />
                </linearGradient>
            </defs>
        </svg>
    );
};
